const state = {
  body_booking_fast: {},
  isShowSearchFacility: false,
  list_teetime: [],
  listPriceFacility: [],
  review_facility: [],
  list_news: [],
  list_news_top: [],
  list_category_tee: []
};

const mutations = {
  UPDATE_BODY_BOOKING_FAST: (state, new_data) => {
    // console.log("vao day .....................", new_data);
    state.body_booking_fast = new_data;
  },
  RESET_BODY_BOOKING_FAST: state => {
    state.body_booking_fast = {};
  },
  SHOW_DIALOG_FACILITY: (state, data) => {
    state.isShowSearchFacility = data;
  },
  UPDATE_TEETIME: (state, data) => {
    state.list_teetime = data;
  },
  SET_DATA_PRICE_FACILITY: (state, data) => {
    state.listPriceFacility = data;
  },
  SET_DATA_REVIEW_FACILITY: (state, data) => {
    state.review_facility = data;
  },
  SET_DATA_NEW: (state, data) => {
    state.list_news = data;
  },
  SET_DATA_NEW_TOP: (state, data) => {
    state.list_news_top = data;
  },
  SET_DATA_CATEGORY_TEE: (state, data) => {
    state.list_category_tee = data;
  }
};

const actions = {
  update_body_booking_fast(context, data) {
    context.commit("UPDATE_BODY_BOOKING_FAST", data);
  },
  reset_body_booking_fast(context) {
    context.commit("RESET_BODY_BOOKING_FAST");
  },
  show_dialog_search_facility(context, data) {
    context.commit("SHOW_DIALOG_FACILITY", data);
  },
  update_teetime(context, data) {
    context.commit("UPDATE_TEETIME", data);
  },
  set_data_price_facility(context, data) {
    context.commit("SET_DATA_PRICE_FACILITY", data);
  },
  set_data_review_facility(context, data) {
    context.commit("SET_DATA_REVIEW_FACILITY", data);
  },
  set_data_news(context, data) {
    context.commit("SET_DATA_NEW", data);
  },
  set_data_news_top(context, data) {
    context.commit("SET_DATA_NEW_TOP", data);
  },
  set_data_category_tee(context, data) {
    context.commit("SET_DATA_CATEGORY_TEE", data);
  }
};

export default {
  state,
  mutations,
  actions
};
